export default __webpack_public_path__ + "static/media/mec_logo1.65052144.png";